import { RootState } from '../store'
import { ActivationState } from './AccountActivation.slice'

export default (state: RootState): ActivationState => state.accountActivation
